import React from "react";
import { Flame, Zap, ArrowRight, CheckCircle2 } from "lucide-react";

const HEAT = {
  hot: "bg-rose-100 text-rose-700 border-rose-200",
  warm: "bg-amber-100 text-amber-800 border-amber-200",
  cool: "bg-slate-100 text-slate-500 border-slate-200",
  won: "bg-emerald-100 text-emerald-700 border-emerald-200",
  closed: "bg-slate-100 text-slate-400 border-slate-200",
};

const ICON = { hot: Flame, warm: Zap, won: CheckCircle2 };

export function PhaseChip({ signal, testid }) {
  if (!signal || !signal.headline) return null;
  const cls = HEAT[signal.heat] || HEAT.cool;
  const Icon = ICON[signal.heat];
  return (
    <span data-testid={testid} title={signal.phase}
      className={`inline-flex items-center gap-1 text-[10px] font-semibold rounded px-1.5 py-0.5 border ${cls}`}>
      {Icon && <Icon className="w-2.5 h-2.5" />}{signal.headline}
    </span>
  );
}

export function NextAction({ signal, testid }) {
  if (!signal || !signal.action) return null;
  return (
    <div data-testid={testid} className="text-[11px] text-[#003E87] mt-1 flex items-center gap-1">
      <ArrowRight className="w-3 h-3 shrink-0" /> {signal.action}
    </div>
  );
}
